// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"286fe080","703":"d94ae62f"}[chunkId] + ".chunk.js";
};